
import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from "../../environments/environment";

@Component({
  selector: 'app-offline-daily-report',
  templateUrl: './offline-daily-report.component.html',
  styleUrls: ['./offline-daily-report.component.css']
})
export class OfflineDailyReportComponent implements OnInit {

  route:string;
  firstLevelExceedance:any = [];
  secondLevelExceedance:any = [];
  exceedanceIndustryList = [];
  industryParameterCount = [];
  exceedanceIndustryHistory = [];
  regionList = [];
  regionFilter = '';
  sum = 0;
  exceededSum = 0;
  selectedOfficerNameExceedance = '';
  selectedExceedanceStationIDs = '';
  selectedRegionNameExceedance = '';
  moreDetailDrilledExceedance = false;
  selectedIndustryNameExceedance = '';
  selectedIndustryAddressExceedance = '';
  regionLoaderExceedance = false;
  industryLoaderExceedance = false;
  historyLoaderExceedance = false;
  oldFormat = false;

  startReportDate:Date;
  endReportDate = new Date();
  currentReportDate = new Date();
  oneDayBeforeDate = new Date();
  maxStartDate : Date;
  maxEndDate : Date;

  startReportTime: Date;
  endReportTime: Date;

  startDate = '';
  endDate = '';
  startTime = '';
  endTIme = '';

  userData:any = [];

  userName;
  userLevel;
  searchField = {};
  public apiBaseUrl: string = environment.apiBaseUrl;
  regionLoader = false;
  closeIndustryList = [];
  industrySettings={};
  stationSettings={};
  industryList=[];
  vendorList=[];
  categoryList=[];
  timeUnitList=[];
  stationList=[]
  industryParameterList = [];

  start_date="";
  end_date="";
  aggregationFilter='1';
  timeIntervalFilter:any="1";
  categoryFilter="";
  unitTypeFilter="";
  vendorFilter="";
  industryFilter=[];
  stationFilter=[];
  endTime = '';
  currentRoute: any;
  otherDetails={}
  timeIntervalArray=["Actual", "15 minute", "30 min", "Hourly", "Daily", "Monthly", "Quarterly", "Yearly"];
  selectedIndustryId
  selectedVendorId

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) {

    this.maxStartDate = new Date();
    this.maxEndDate = new Date();

  }

  ngOnInit() {

    var d = new Date();
    this.startReportDate = d;

    this.userData = JSON.parse(localStorage.getItem('userData'));

    // if (this.userData && this.userData['user_profile_id'] != undefined && this.userData['user_profile_id'] != 'IT001' && this.userData['user_profile_id'] != 'HSPCBCEMS') {
    //   this.router.navigate(['dashboard']);
    // }
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }
    this.selectedIndustryId = this.userName;

    this.selectedVendorId = this.userData['id']?this.userData['id']:'';

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }
    if(this.userLevel == 'industry'){
      this.searchField['industryId'] = this.userName;
    }
    if(this.userLevel == 'vendor'){
      this.vendorFilter = this.userData['id']?this.userData['id']:'';
      this.vendorId = this.userData['id']?this.userData['id']:'';
    }


    this.getExceededIndustry();
    this.getRegionList();
    this.settings();
    // this.getIndustryList();
    // this.getVendorList();
    // this.getCategoryList();
    // this.getTimeUnitList();
    // this.getStationList();
  }
  settings(){
    this.industrySettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1
    };
    this.stationSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1
    };
  }


  onStartDateChange(value: Date): void {
    this.startReportDate = value;
  }

  onEndDateChange(value: Date): void {
    this.endReportDate = value;
  }

  locationsSum() {
    return this.firstLevelExceedance.map(tag => tag.total_stations).reduce((a, b) => a + b, 0);
  }
  locationsExceededSum() {
    return this.firstLevelExceedance.map(tag => tag.total_inactive_stations).reduce((a, b) => a + b, 0);
  }

  // tslint:disable-next-line:member-ordering
  secondLevelType = 'all_station_ids';
  getStationIDs(key, type){
    let stationIDs = '';
    if(this.firstLevelExceedance.length){
      for(let i=0; i < this.firstLevelExceedance.length; i++){
        if(this.firstLevelExceedance[i][key]){
          stationIDs = stationIDs+this.firstLevelExceedance[i][key]+',';
        }
      }
    }
    stationIDs = stationIDs.slice(-1)== ',' ? stationIDs.slice(0,-1) : stationIDs;
    if (type == 'offline') {
      this.secondLevelType = 'offline_station_ids';
      if (this.start_date < '2021-06-27' || this.end_date < '2021-06-27') {
        this.oldFormat = true;
        this.getAggregateIndustryList(stationIDs, 'get-offline-stations-list-region-wise-old');
      } else {
        this.oldFormat = false;
        this.getAggregateIndustryList(stationIDs, 'get-offline-stations-list-region-wise');
      }
    } else {
      if (this.start_date < '2021-06-27' || this.end_date < '2021-06-27') {
        this.oldFormat = true;
        this.getAggregateIndustryList(stationIDs, 'get-all-offline-stations-list-region-wise');
      } else {
        this.oldFormat = false;
        this.getAggregateIndustryList(stationIDs, 'get-all-offline-stations-list-region-wise');
      }
    }
    document.getElementById('openModalButton').click();

  }

  getExceedanceIndustryList(stationIDs){

    this.industryLoaderExceedance = true;
    this.moreDetailDrilledExceedance = false;
    this.selectedExceedanceStationIDs = stationIDs;
    this.secondLevelType = 'offline_station_ids';

    if (this.start_date < '2021-06-27' || this.end_date < '2021-06-27') {
      this.oldFormat = true;
      this.route  = 'get-offline-stations-list-region-wise-old';
    } else {
      this.oldFormat = false;
      this.route  = 'get-offline-stations-list-region-wise';
    }

    const token = localStorage.getItem('userToken');

    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
      'industry_id':this.industryFilter.map((item)=>item.id).join(),
      'vendor_id':this.vendorFilter,
      'unit_type':this.unitTypeFilter,
      'category_type':this.categoryFilter,
      'region':this.regionFilter,
      'start_date':this.start_date,
      'end_date':this.end_date,
      'aggregation':this.aggregationFilter,
      'time_interval':this.timeIntervalFilter,
      'station_ids': this.selectedExceedanceStationIDs
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.secondLevelExceedance = response.result;
      }
      this.industryLoaderExceedance = false;
    });
  }

  getExceededIndustry(){

    if(this.startReportDate){
      var sdate = this.convertDateFormat(this.startReportDate);
    }

    if(this.endReportDate){
      var edate = this.convertDateFormat(this.endReportDate)
    }

    if(this.startReportTime){
      var stime = this.convertTimeFormat(this.startReportTime)
    }

    if(this.endReportTime){
      var etime = this.convertTimeFormat(this.endReportTime)
    }

    //this.startDate=this.combineDateTime(sdate,stime);
    //this.endDate=this.combineDateTime(edate,etime);


    if(sdate){
      if(stime){
        this.start_date = sdate + ' ' + stime;
      } else{
        this.start_date = sdate + ' 00:00:00';
      }
    }
    if(edate){
      if(etime){
        this.end_date = edate + ' ' + etime;
      } else{
        this.end_date = edate + ' 23:59:59';
      }
    }
    this.regionLoaderExceedance = true;
    this.route  = 'get-offline-stations-region-wise';
    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
      'industry_id':this.industryFilter.map((item)=>item.id).join(),
      'vendor_id':this.vendorFilter,
      'unit_type':this.unitTypeFilter,
      'category_type':this.categoryFilter,
      'region':this.regionFilter,
      'start_date':this.start_date,
      'end_date':this.end_date,
      'aggregation':this.aggregationFilter,
      'time_interval':this.timeIntervalFilter
    };
    // console.log(data); return;
    const token = localStorage.getItem('userToken');
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){

        console.log(response.result);

        this.firstLevelExceedance = response.result;
      }
      this.regionLoaderExceedance = false;
    });
  }

  getAggregateIndustryList(stationIDs, route){

    this.industryLoaderExceedance = true;
    this.moreDetailDrilledExceedance = false;
    this.selectedExceedanceStationIDs = stationIDs;

    const token = localStorage.getItem('userToken');

    let data = { 'station_id':this.stationFilter.map((item)=>item.id).join(),
      'industry_id':this.industryFilter.map((item)=>item.id).join(),
      'vendor_id':this.vendorFilter,
      'unit_type':this.unitTypeFilter,
      'category_type':this.categoryFilter,
      'region':this.regionFilter,
      'start_date':this.start_date,
      'end_date':this.end_date,
      'aggregation':this.aggregationFilter,
      'time_interval':this.timeIntervalFilter,
      'station_ids': this.selectedExceedanceStationIDs
    };

    this._service.postRequestCreator(data, route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.secondLevelExceedance = response.result;
      }
      this.industryLoaderExceedance = false;
    });
  }

  industryExceedanceHistoryData : any;

  getIndustryExceedanceHistory(val){

    this.industryExceedanceHistoryData = val;

    this.historyLoaderExceedance = true;
    this.moreDetailDrilledExceedance = true;


    let industry_id = '';
    if (this.start_date < '2021-06-27' || this.end_date < '2021-06-27') {
      this.selectedIndustryNameExceedance = this.industryExceedanceHistoryData.industry_name;
      this.selectedIndustryAddressExceedance = this.industryExceedanceHistoryData.industry_address;
      industry_id = this.industryExceedanceHistoryData.industry_id;

      this.oldFormat = true;
      this.route  = 'get-offline-station-industry-daily-report-old';
    } else {
      this.selectedIndustryNameExceedance = this.industryExceedanceHistoryData[0][0].industry_name;
      this.selectedIndustryAddressExceedance = this.industryExceedanceHistoryData[0][0].industry_address;
      industry_id = this.industryExceedanceHistoryData[0][0].industry_id;

      this.oldFormat = false;
      this.route  = 'get-offline-station-industry-daily-report';
    }

    const token = localStorage.getItem('userToken');

    let data = {
      'station_id':this.stationFilter.map((item)=>item.id).join(),
      'station_ids':this.selectedExceedanceStationIDs,
      'industry_id':industry_id,
      'vendor_id':this.vendorFilter,
      'unit_type':this.unitTypeFilter,
      'category_type':this.categoryFilter,
      'region':this.regionFilter,
      'start_date':this.start_date,
      'end_date':this.end_date,
      'aggregation':this.aggregationFilter,
      'time_interval':this.timeIntervalFilter
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.exceedanceIndustryHistory = response.result.data;
      }
      this.historyLoaderExceedance = false;
    });
  }

  backToPreviousLevelExceedance(){
    this.moreDetailDrilledExceedance = false;
  }

  region = "";
  industry_category = "";
  industry_type = "";
  vendorId = "";
  industry_id = "";
  station_id = "";

  getRegionList(){

    this.route  = 'get-region-list';
    const token = localStorage.getItem('userToken');

    let data = [];

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.regionList = response.data;
      }
      this.getCategoryList();
    }, error =>{
      this.getCategoryList();
    });
  }

  getCategoryList(region = null){


    this.route  = 'get-industry-categories';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(region){
      this.region = region.target.value;
    } else{
      this.region = "";
    }
    data = {'region' : this.region};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.categoryList = response.data;
      }
      this.getTimeUnitList();
    }, error =>{
      this.getTimeUnitList();
    });

  }

  getTimeUnitList(industry_category = null){

    this.route  = 'get-industry-type';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_category){
      this.industry_category = industry_category.target.value;
    } else{
      this.industry_category = "";
    }
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category
    };

    if(industry_category){
      data = {'industry_category' : industry_category.target.value};
    }
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.timeUnitList = response.data;
      }
      this.getVendorList();
    }, error =>{
      this.getVendorList();
    });
  }

  getVendorList(industry_type = null){
    this.route  = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(industry_type){
      this.industry_type = industry_type.target.value;
    } else{
      this.industry_type = "";
    }
    data = {
      'region' : this.region,
      'industry_category' : this.industry_category,
      'industry_type' : this.industry_type,
      'vendor_id':this.vendorFilter,

    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        let vendorListM = response.data;
        this.vendorList=  response.data;
        // this.vendorList=vendorListM.filter((item)=>item.id==this.selectedVendorId)
      }
      this.getIndustryList();
    }, error =>{
      this.getIndustryList();
    });
  }

  getIndustryList(vendor_id = null){
    this.industryFilter=[]
    this.route  = 'get-all-industry-details';
    const token = localStorage.getItem('userToken');

    let data = {};
    if(vendor_id){
      this.vendorId = vendor_id.target.value;
    } else{
      this.vendorId = "";
    }

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }
    if(this.userLevel == 'industry'){
      this.industry_type = this.userName;
    }
    if(this.userLevel == 'vendor'){
      this.vendorFilter = this.userData['id'] ? this.userData['id']:'';
      this.vendorId = this.userData['id']?this.userData['id']:'';
    }

    let search_fields = {
      'region' : this.region,
      'categoryType' : this.industry_category,
      'industryType' : this.industry_type,
      'vendorId' : this.vendorId
    };

    data = {'search_fields' : search_fields}
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        let industryListM = response.data;
        this.industryList=response.data;
        // this.industryList=industryListM.filter((item)=>this.selectedIndustryId==item.code)
      }
      this.getStationList();
    }, error =>{
      this.getStationList();
    });
  }

  getStationList(industry_id = null,all=null){
    this.stationFilter=[]
    this.route  = 'get-ind-station-details';
    const token = localStorage.getItem('userToken');
    let data = {};
    if(all){
      this.industryFilter=industry_id
    }
    if(industry_id){
     this.industry_id= this.industryFilter.map((item)=>item.id).join();

    } else{
      this.industry_id = "";
    }

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }

    if(this.userLevel == 'industry'){
      this.industry_id = this.userName;
    }

    if(this.userLevel == 'vendor'){
      this.vendorId = this.userData['id']?this.userData['id']:'';
    }

    data = {
      'region' : this.region,
      'industry_category' : this.industry_category,
      'industry_type' : this.industry_type,
      'vendor_id' : this.vendorId,
      'industry_id' : this.industry_id
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.stationList = response.data;
      }
    }, error =>{
    });
  }

  convertDateFormat(dateObj) {

    var result_date = new Date(dateObj);

    var str = result_date.getFullYear() + '-' +
      ((result_date.getMonth()+1) > 9 ? (result_date.getMonth()+1) : ('0'+(result_date.getMonth()+1)))
      + '-' +
      (result_date.getDate() > 9 ? result_date.getDate() : ('0'+result_date.getDate()));

    return str;
  }

  convertTimeFormat(timeObj) {

    if(timeObj){
      var result_time = new Date(timeObj);

      return ((result_time.getHours()) > 9 ? (result_time.getHours()) : ('0'+(result_time.getHours()))) + ':' + ((result_time.getMinutes()) > 9 ? (result_time.getMinutes()) : ('0'+(result_time.getMinutes()))) + ':00';
    }else{
      return '00:00:00'
    }
  }
  combineDateTime(day,time){
    var newDate = new Date(day+"T"+time);
    return newDate;
  }
  exportReport(type){
    var a;
    const token = localStorage.getItem('userToken');


    const industry_status = document.getElementById('industry_status').innerText;

    // console.log(this.industryExceedanceHistoryData.hr_ocmms_id); return;
    a = document.getElementById('export'+type+'href');

    let route = '/offline-industry-daily-export/';

    if (this.start_date < '2021-06-27' || this.end_date < '2021-06-27') {
      route = '/offline-industry-daily-export-old/';
    }
    a.href = this.apiBaseUrl + route + type +"/"+token
      +"?industry_id="+(this.industryExceedanceHistoryData.industry_id ? btoa(this.industryExceedanceHistoryData.industry_id) : (this.industryExceedanceHistoryData[0] && this.industryExceedanceHistoryData[0][0] && this.industryExceedanceHistoryData[0][0].industry_id ? this.industryExceedanceHistoryData[0][0].industry_id : btoa(null)))
      +"&vendor_id="+(this.vendorFilter ? btoa(this.vendorFilter) : btoa(null))
      +"&unit_type="+(this.unitTypeFilter ? btoa(this.unitTypeFilter) : btoa(null))
      +"&category_type="+(this.categoryFilter ? btoa(this.categoryFilter) : btoa(null))
      +"&region="+(this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      +"&start_date="+(this.start_date ? btoa(this.start_date) : btoa(null))
      +"&end_date="+(this.end_date ? btoa(this.end_date) : btoa(null))
      +"&aggregation="+(this.aggregationFilter ? btoa(this.aggregationFilter) : btoa(null))
      +"&time_interval="+(this.timeIntervalFilter ? btoa(this.timeIntervalFilter) : btoa(null))
      +"&station_id="+(this.stationFilter ? btoa(this.stationFilter.map((item)=>item.id).join()) : btoa(null))

      +"&hr_ocmms_id="+(this.industryExceedanceHistoryData.hr_ocmms_id ? btoa(this.industryExceedanceHistoryData.hr_ocmms_id) : btoa(null))
      +"&industry_name="+(this.industryExceedanceHistoryData.industry_name ? btoa(this.industryExceedanceHistoryData.industry_name) : btoa(null))
      +"&industry_address="+(this.industryExceedanceHistoryData.industry_address ? btoa(this.industryExceedanceHistoryData.industry_address) : btoa(null))
      +"&industry_category="+(this.industryExceedanceHistoryData.industry_category ? btoa(this.industryExceedanceHistoryData.industry_category) : btoa(null))
      +"&region_name="+(this.industryExceedanceHistoryData.region_name ? btoa(this.industryExceedanceHistoryData.region_name) : btoa(null))
      +"&industry_status="+(industry_status ? btoa(industry_status) : btoa(null))
      +"&hours_inactive="+(this.industryExceedanceHistoryData.hours_inactive ? btoa(this.industryExceedanceHistoryData.hours_inactive) : btoa(null))
      +"&alert_type="+(this.industryExceedanceHistoryData.alert_type ? btoa(this.industryExceedanceHistoryData.alert_type) : btoa(null))
    ;
    document.getElementById('export'+type+'href').click();
  }

  exportReportFirstLevel(type) {
    var a;
    const token = localStorage.getItem('userToken');
    a = document.getElementById('export'+type+'hrefFirstLevel');
    a.href = this.apiBaseUrl +"/get-offline-stations-region-wise-export/"+type +"/"+token
      +"?industry_id="+(this.industryFilter ? btoa(this.industryFilter.map((item)=>item.id).join()) : btoa(null))
      +"&vendor_id="+(this.vendorFilter ? btoa(this.vendorFilter) : btoa(null))
      +"&unit_type="+(this.unitTypeFilter ? btoa(this.unitTypeFilter) : btoa(null))
      +"&category_type="+(this.categoryFilter ? btoa(this.categoryFilter) : btoa(null))
      +"&region="+(this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      +"&start_date="+(this.start_date ? btoa(this.start_date) : btoa(null))
      +"&end_date="+(this.end_date ? btoa(this.end_date) : btoa(null))
      +"&aggregation="+(this.aggregationFilter ? btoa(this.aggregationFilter) : btoa(null))
      +"&time_interval="+(this.timeIntervalFilter ? btoa(this.timeIntervalFilter) : btoa(null))
      +"&station_id="+(this.stationFilter ? btoa(this.stationFilter.map((item)=>item.id).join()) : btoa(null));
    document.getElementById('export'+type+'hrefFirstLevel').click();
  }

  exportReportSecondLevel(type) {
    let a;
    const token = localStorage.getItem('userToken');
    a = document.getElementById('export'+ type + 'hrefSecondLevel');
    let route;
    if (this.secondLevelType == 'all_station_ids') {
      route = '/get-all-offline-list-region-wise-export/';
    } else {
      if (this.start_date < '2021-06-27' || this.end_date < '2021-06-27') {
        route = '/get-offline-list-region-wise-export-old/';
      } else {
        route = '/get-offline-list-region-wise-export/';
      }
    }


    a.href = this.apiBaseUrl + route + type + "/" + token
      +"?industry_id=" + (this.industryFilter ? btoa(this.industryFilter.map((item) => item.id).join()) : btoa(null))
      +"&station_id=" + (this.stationFilter ? btoa(this.stationFilter.map((item) => item.id).join()) : btoa(null))
      +"&vendor_id=" + (this.vendorFilter ? btoa(this.vendorFilter) : btoa(null))
      +"&unit_type=" + (this.unitTypeFilter ? btoa(this.unitTypeFilter) : btoa(null))
      +"&category_type=" + (this.categoryFilter ? btoa(this.categoryFilter) : btoa(null))
      +"&region=" + (this.regionFilter ? btoa(this.regionFilter) : btoa(null))
      +"&start_date=" + (this.start_date ? btoa(this.start_date) : btoa(null))
      +"&end_date=" + (this.end_date ? btoa(this.end_date) : btoa(null))
      +"&aggregation=" + (this.aggregationFilter ? btoa(this.aggregationFilter) : btoa(null))
      +"&time_interval=" + (this.timeIntervalFilter ? btoa(this.timeIntervalFilter) : btoa(null))
      +"&station_ids=" + (this.selectedExceedanceStationIDs ? btoa(this.selectedExceedanceStationIDs) : btoa(null));
    document.getElementById('export' + type + 'hrefSecondLevel').click();
  }

  SUM(data) {
    let sum = 0;
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].length; j++) {
        sum += parseFloat(data[i][j]['hours_inactive']);
      }
    }
    return sum;
  }
}

